<template>
	<div>
		<div class="d-flex align-center justify-end mb-2 mt-2 px-2">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="loadingList"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="client_contracts_count"
				:loading-info="loadingList"
			/>
		</div>
    <v-data-table
			ref="table"
			:headers="headers"
			:items="client_contracts"
			item-key="id"
			:loading="loadingList"
			:server-items-length="client_contracts_count"
			:options.sync="options"
			loading-text="Cargando datos..."
			class="crm-table"
			:class="$vuetify.breakpoint.mobile ? '':'resizable'"
			disable-sort
			hide-default-footer
			@click:row="selectRow"
			:item-class="selectedRowClass"
			:footer-props="{
        itemsPerPageText: 'Filas por página'
			}"
    >
      <template v-slot:item.code="{ item }">
				<p class="caption mb-0">
					<b class="text-end" style="flex: 1;">{{ item.serial?.serial }} - LP{{ item.morphable?.project_line_info?.project_line?.number }} - {{ item.info?.prefix?.prefix }} {{ getContractPrefixIndex(item) }} {{ getContractSuffix(item) }}</b>
				</p>
      </template>
      <template v-slot:item.company="{ item }">
				<div class="text-start">
					<p class="mb-0 caption"><b>Empresa:</b> {{ item.morphable?.company?.name }}</p>
					<p class="caption mb-0"><b>Proyecto:</b> {{ item.morphable?.name || item.morphable?.info?.project_detail || '--' }}</p>
					<p class="caption mb-0"><b>Dirección:</b> {{item.morphable?.info?.address?.address ?? '--'}} {{item.morphable?.info?.address?.district?.name ?? '--'}}</p>
				</div>
      </template>
			<template v-slot:item.contract_date="{ item }">
				<div>
					<p class="caption mb-0">{{item.created_at | toDate}}</p>
				</div>
			</template>
      <template v-slot:item.status="{ item }">
				<div>
					<v-chip
						:color="item.last_status?.status | contractStatusColor"
						label
						outlined
						x-small
						class="px-1"
					>
						<b>{{ item.last_status?.status | contractStatus }}</b>
					</v-chip>
					<p class="ml-2 mb-0 caption">{{ item.last_status?.description }}</p>
				</div>
			</template>
      <template v-slot:item.actions="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							class="mx-1"
							icon
							dark
							x-small
							color="primary"
							@click.stop="() => { selectRow(item); openContractDetail(item.id); }"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-eye</v-icon>
						</v-btn>
					</template>
					<span>Ver Detalle</span>
				</v-tooltip>
      </template>
    </v-data-table>
		<div class="d-flex align-center justify-end mt-2 px-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="client_contracts_count"
				:loading-info="loadingList"
			/>
		</div>
	</div>
</template>

<script>
// import moment from 'moment'
import _debounce from 'lodash/debounce'
import {getClientContracts} from '@/helpers/api/clients'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'

export default {
	name: 'ClientsContractList',
	components: {
		DataTablePagination
	},
	props: {
		clientId: {
      type: Number,
      required: true
    },
		openContractDetail: {
      type: Function,
      required: true
    }
	},
	computed: {
		selected_contract() {
			return this.$route.query?.ct
		}
	},
	watch: {
    options: {
      handler() {
				this.getClientContracts()
      },
      deep: true,
    }
	},
	data: () => ({
		selectedRowItem: null,
		loadingList: true,
		client_contracts: [],
		client_contracts_count: 0,
		headers: [
			{ text: 'Nº', value: 'code', align: 'start', sortable: false },
			{ text: 'Detalle', value: 'company', align: 'start', sortable: false },
			{ text: 'Fecha Creación Contrato', value: 'contract_date', align: 'center', sortable: false },
			{ text: 'Estado', value: 'status', align: 'center', sortable: false },
			{ text: 'Acciones', value: 'actions', sortable: false },
		],
		searchInput: null,
		options: {
			page: 1,
			itemsPerPage: 10,
			sortBy: [],
			sortDesc: [],
		},
	}),
	mounted(){
		this.getClientContracts()
		const contract_id = this.$route.query.ct
		if(contract_id){
			this.selectedRowItem = contract_id
			this.openContractDetail(contract_id)
		}
		else{
			const selectedRow = JSON.parse(localStorage.getItem('selected_clients_contracts_row'));
			if (selectedRow) {
				this.selectedRowItem = selectedRow
			}
		}
    eventBus.$on('reloadInformation', this._onReloadContract)
	},
	beforeDestroy(){
		eventBus.$off('reloadInformation', this._onReloadContract);
	},
	methods: {
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_clients_contracts_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		getContractPrefixIndex(contract){
			const parent = contract.addendum_parent || contract.subcontract_parent
			if(parent){
				return parent.info?.contract_prefix_index
			}
			return contract.info?.contract_prefix_index
		},
		getContractSuffix(contract){
			if (contract.addendum_to_contract_id) {
				return ` - ANX Nº ${contract.addendum_index}`;
			}
			else if (contract.subcontract_to_contract_id) {
				return ` - SUB Nº ${contract.subcontract_index}`;
			}
			return '';
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.getClientContracts()
		},
		_onReloadContract(){
			this.getClientContracts()
		},
		getRowClass(item) {
			return item.id == this.selected_contract ? 'custom-client-highlight-row' : '';
		},
		async getClientContracts(){
			this.loadingList = true
			try {
				let data = {
					...this.options,
					client_id: this.clientId,
					start: (this.options.page - 1) * this.options.itemsPerPage,
					limit: this.options.itemsPerPage,
				}
				if(this.searchInput){
					data = {...data, ...{search: this.searchInput}}
				}
				const client_contract = await getClientContracts(data)
				if(client_contract.code == 200){
					this.client_contracts = client_contract.client_contracts
					this.client_contracts_count = client_contract.client_contracts_count
				}
			} catch (error) {
				console.log(error)
			}
			this.loadingList = false
		},
	}
}
</script>

<style>
.custom-client-highlight-row {
  background-color: #e8e8e8 !important;
}
</style>